import React from "react";
import { cn } from "@/lib/utils";
import { Button } from "./button";
import { Plus } from "lucide-react";

export interface EmptyStateProps {
  icon?: React.ElementType;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: React.ElementType;
  className?: string;
  children?: React.ReactNode;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  actionIcon: ActionIcon = Plus,
  className,
  children,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center p-8 text-center rounded-xl border border-dashed border-border/80 bg-muted/10 transition-colors",
        className
      )}
    >
      {Icon && (
        <div className="h-10 w-10 rounded-xl bg-muted flex items-center justify-center text-muted-foreground mb-3 shadow-2xs">
          <Icon className="h-5 w-5" />
        </div>
      )}

      <h3 className="text-sm font-semibold text-foreground tracking-tight">{title}</h3>

      {description && (
        <p className="text-xs text-muted-foreground mt-1 max-w-sm leading-relaxed">
          {description}
        </p>
      )}

      {actionLabel && onAction && (
        <Button
          size="sm"
          onClick={onAction}
          className="mt-4 text-xs h-8 gap-1.5 font-medium shadow-xs"
        >
          <ActionIcon className="h-3.5 w-3.5" />
          <span>{actionLabel}</span>
        </Button>
      )}

      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}
